import BaseModule from './BaseModule';

class IndexModule extends BaseModule {

  constructor() {
    super()
  }
  /**
   * feed流获取数据方法
   * @param {*} options 配置项
   * @params news_id	文章id	string	否	news_id="1,2,3,4,5"
   * @params category_id	分类id	int	否	category_id=1
   * @params limit
   * @params host-是否热门-int-非必填-host=1获取热门
   * @params special是否是专题	int	否	special=1-获取专题
   * @params after_id
   * @params before_id
   * @params token
   * @params essence_level精华等级 1-精华1,2-精华2,3-精华3,4-精华4 int	否	essence_level=1
   * @params author_id	作者id  int	否	author_id=1
   * @params net_work	网络类型 1-2G，2-3G，3-4G，4-WIFI   int	否	net_work=3
   * @params video=1
   * @params audio=1
   */
  getFeedStream(params) {
    return this.post(`news/enfeedstream`, params);
  }
  /**
  * 订阅接口 -- 通过传入邮箱订阅新闻
  * @params email  String 是
  * 激活邮件
  * @params email 邮箱地址 String 是
  * @params code 签名 String 是
  * 取消订阅
  * @params email 邮箱地址 String 是
  * @params code 签名 String 是
  * @params remarks 取消原因 String 否
  */ 
  subscribe(params) {
    return this.post(`subscribe/order`, params);
  }
  /**
  * 激活邮件
  * @params email 邮箱地址 String 是
  * @params code 签名 String 是 
  */
  subActive(params) {
    return this.post(`subscribe/active`, params);
  }
  /**
  * 取消订阅
  * @params email 邮箱地址 String 是
  * @params code 签名 String 是
  * @params remarks 取消原因 String 否
  */ 
  subCancel(params) {
    return this.post(`subscribe/cancel`, params);
  }
  /**
  * 资讯搜索接口
  * @params source 来源 string 是 “pc”
  * @params query 搜索内容 string 是 
  * @params news_type 搜索资讯状态 obj 否 支持多选news_type=[1] （0无图，1单图，2多图，3视频，4音频）文章搜索传[0,1,2] json数组
  * @params page 页码 obj 否
  * @params limit 个数 int 否
  * @params search_after 无页码分页 obj 否
  * @params token 身份验证码 string 否
  * @params keyword_type  关键词类型（神策用） string 否
  * @params distinct_id 神策的设备id string 否 distinct_id=神策的设备id（加入埋点后和token二选一，必须传一个）
  * @params vip vip内容  string 否 vip=1 （0普通新闻 1vip新闻 默认为0)
  * @params category_id 栏目ID string 否
  */ 
  getSearch(params) {
    return this.post(`search/news`, params);
  }
}

export default new IndexModule();